import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { media, TransitionMixin } from '../../helpers';

import ProductDetails from '../product-details';

const CustomizerProductVariantsContainer = styled.div`
    .variants-container {
        display: flex;
        flex-wrap: wrap;

        .selectors-container {
            display: flex;
            flex-wrap: wrap;
            padding-top: 0px;
            flex: 1 1 100%;
            margin-bottom: 20px;
            ${media.large`flex: 2; margin-bottom: 0px;`}
            .select-container {
                flex: 1 1 100%;
                position: relative;
                margin-right: 0px;
                margin-bottom: 40px;
                &:last-child {
                    margin-right: 0px;
                    ${media.large`margin-right: 0px;`}
                }

                h4 {
                    margin: 0 0 10px;
                    font-size: 0.9rem;
                    display: inline-block;
                }

                select {
                }
                svg {
                }
            }
        }
        .qty-outer-container {
            flex: 1 1 100%;
            display: flex;

            .qty-container {
                display: inline-flex;
                align-items: flex-end;
                flex: 0 0 50%;

                .input-container {
                    h4 {
                        margin: 0 0 10px;
                        font-size: 0.9rem;
                    }
                    input {
                        height: 40px;
                        max-width: 60px;
                        background-color: #f2f0eb;
                        border: 1px solid #767676;
                        margin-right: 15px;
                        border-radius: 5px;
                        -webkit-appearance: none;
                        text-align: center;
                        &::-webkit-outer-spin-button,
                        &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }
                    }
                }
                .btn-container {
                    display: flex;
                    align-items: baseline;
                    button {
                        line-height: 1;
                        border: none;
                        background-color: #fff;
                        padding: 0;

                        &:hover {
                            opacity: 0.6;
                        }

                        svg {
                            stroke-width: 1.3px;
                            height: 32px;
                            width: 32px;
                        }
                    }
                }
            }
            .mobile-wishlist {
                flex: 0 0 50%;
                align-self: flex-end;
                ${media.large`display: none;`}
            }
            .custom-size-guide {
                display: flex;
                align-items: flex-end;
                position: relative;
                bottom: 8px;
                flex: 1;
                justify-content: flex-end;
                a {
                    font-size: 0.85rem;
                    color: #702716;
                    ${TransitionMixin('.25s')}
                    &:hover {
                        opacity: 0.7;
                    }
                }
            }
        }
    }
`;

const CustomizerProductVariants = ({ product, currentPalette }) => {
    const [currentVariant, setCurrentVariant] = useState();
    const [qty, setQty] = useState(1);

    function handleVariantChange(variant) {
        console.log('changing variant');
        setCurrentVariant(variant);

        let newColor;
        variant.selectedOptions.map((option) => {
            if (option.name === 'Color') {
                newColor = option.value;
            }
        });
    }

    useEffect(() => {
        // TODO: make first load behavior conditional based on link
        const firstVariant = product.variants[0];
        let firstColor;
        firstVariant.selectedOptions.map((option) => {
            if (option.name === 'Color') {
                firstColor = option.value;
            }
        });
        setCurrentVariant(firstVariant);
    }, []);

    return (
        <CustomizerProductVariantsContainer>
            <ProductDetails
                handleVariantChange={handleVariantChange}
                qty={qty}
                setQty={setQty}
                currentVariant={currentVariant}
                product={product}
                custom={true}
                currentPalette={currentPalette}
            />
        </CustomizerProductVariantsContainer>
    );
};

export default CustomizerProductVariants;
